module.exports = __webpack_public_path__ + "static/media/fb-icon.890100cd.svg";